import { render, staticRenderFns } from "./NewsAsideList.vue?vue&type=template&id=71c7619a&scoped=true&"
import script from "./NewsAsideList.vue?vue&type=script&lang=js&"
export * from "./NewsAsideList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7619a",
  null
  
)

export default component.exports